var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('transition-group',{attrs:{"name":"slide-fade"}},_vm._l((_vm.notifications),function(notif){return _c('notification-message',{key:notif.id,attrs:{"notif":notif}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }